(function () {
    'use strict';

    angular
        .module('app')
        .directive('windowEvent', windowEventDirective);

    windowEventDirective.$inject = ['$window',/*'debug',*/];

    function windowEventDirective($window/*, debug*/) {
        var directive = {
            restrict: 'A',
            link: link,
        };

        function link(scope) {
            angular.element($window).bind('resize', function () {
                scope.windowWidth = $window.innerWidth;
                // debug.log(scope.windowWidth);
            });
        }

        return directive;
    }
})();